import { module } from 'angular';
import imgZoom from './img-zoom.component';

export default module('app')
	.component('imgZoom', imgZoom)
	.name;
